<template>
    <div>

      <luma-datatable :url="url"
                      :columns="columns"
                      :model="domain"
                      :order="order"  >
      </luma-datatable>



    </div>
</template>

<script>
    import LumaDatatable from "@/components/LumaDatatable"
    import DomainPrice from "@/store/models/domain/domain_price"
    export default {
        components:{LumaDatatable},
        name: "domain-price-list",
        data:()=>({
          url: "/accounting/pricing/domains",

            domain: DomainPrice,
            order:{
                'tld': 'asc'
            }


        }),

        computed:{

            columns(){
                const headers = ['tld', 'create', 'transfer','renew','update','ownerchange','restore']

                return headers.map(el=>({
                    key:el,
                    column:el,
                    filter:true,
                    order:true,
                    format: el!=='tld'?'currency':''
                }
                ))

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/price_domain/domain-price-list.vue